<template>
	<div class="filters-box-row">
		<div class="search-box">
			<div class="input-box">
				<span>店铺名称：</span>
				<el-input
					v-model="content"
					placeholder="店铺名称"
					class="name-input"
					size="mini"
					@keyup.enter.native="onSearch"
					></el-input>
			</div>
            <div class="input-box">
				<span>店铺编号：</span>
				<el-input
					v-model="code"
					placeholder="店铺编号"
					class="name-input"
					size="mini"
					@keyup.enter.native="onSearch"
					></el-input>
			</div>
			<div class="input-box">
				<span>支付方式：</span>
				<el-select v-model="paytype" class="select-box" size='mini' placeholder="支付方式">
					<el-option :value="-1" label="全部"></el-option>
                    <!-- <el-option :value="0" label="不限"></el-option> -->
                    <el-option :value="2" label="微信支付"></el-option>
                    <el-option :value="6" label="微企付"></el-option>
                    <el-option :value="7" label="云资金-网商余额支付"></el-option>
                    <el-option :value="8" label="云资金-汇付支付"></el-option>
					<el-option :value="9" label="云资金-中信支付"></el-option>
                    <el-option :value="10" label="云资金-富友账户通支付"></el-option>
                    <el-option :value="11" label="B2b门店助手-微信支付"></el-option>
                    <el-option :value="12" label="B2b门店助手-银行转账"></el-option>
										<el-option :value="13" label="云资金-网商收银台"></el-option>
										<el-option :value="14" label="拉卡拉全渠道-余额支付"></el-option>
										<el-option :value="16" label="拉卡拉钱包余额"></el-option>
					<!-- // TODO 过滤拉卡拉全渠道-收银台 -->
<!--										<el-option :value="15" label="拉卡拉全渠道-收银台"></el-option>-->
				</el-select>
			</div>
			<div class="input-box-btn">
                <el-button
					type="primary"
					class="search-btn fx-btn"
					size="small"
					@click="onSearch">查询</el-button>
				<el-button
					class="search-btn fx-btn"
					size="small"
                    plain
					@click="clear">清空</el-button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Search',
	props: {

	},
	data () {
		return {
			paytype: -1,
			content: '',
			code: ''
		}
	},
	methods: {
		clear () {
			this.code = ''
			this.paytype = -1
			this.content = ''
			this.onSearch()
		},
		onSearch () {
			let params = {
				content: this.content,
				code: this.code,
				paytype: this.paytype,
				page: 1,
				size: 20
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/payCenter/list`,
				data: params
			}).then(res => {
				// console.log(res)
				if (res.result) {
					// res.data.recordList.forEach(item => {
					// 	let arr = []
					// 	let way = ['微信支付', '招行支付', '民生银行']
					// 	if (item.paychannel !== 0) {
					// 		arr.push(way[item.paychannel - 1])
					// 	}
					// 	if (item.tenpay === 1) {
					// 		arr.push('微企付')
					// 	}
					// 	item.payMethod = arr.join(',')
					// })
					this.$emit('getTableData', res.data)
					this.$emit('getParamsData', params)
				} else {
					this.$message.error(res.msg)
					this.$emit('getParamsData', params)
				}
			}).catch(() => {
				this.$emit('getParamsData', params)
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.filters-box-row{
    border-radius :10px;
	height:60px;
    width :100%;
    line-height :60px;
    min-width :1100px;
	.el-range-editor--small.el-input__inner{
		width :250px;
		margin-right:20px
	}
	.search-box{
		border-bottom :1px solid #dce2fd
		width:100%;
		display:flex;
		flex-wrap:wrap;
		.input-box-btn{
			width :180px;
		}
		.input-box{
            // margin-left :10px;
			width :240px;
			.name-input {
				width: 160px;
				margin-right: 10px;
			}
			.select-box{
				width:160px;
				margin-right:10px;
			}
		}
	}
}
</style>
